import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { EIcon } from '@shared/enums/icon.enum';
import { UserData } from '@shared/interfaces/user-data';
import { RestUserModel } from '@shared/interfaces/user.interface';
import { AvatarService } from '@ui-components/components/avatar/services/avatar.service';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent extends ComponentAbstract implements OnInit {
  readonly SYSTEM_USER_ID = 1;

  userId = 0;
  fullName = '';
  firstName = '';
  lastName = '';
  avatarTheme = 'default';

  @Input() set userInfo(userInfo: RestUserModel | UserData) {
    this.avatarTheme = this.avatarService.getUserConfig(userInfo?.id);
    this.userId = userInfo?.id;
    if (userInfo?.id === this.SYSTEM_USER_ID) {
      this.avatarTheme = 'system';
      this.firstName = 'System';
      this.lastName = '';
    } else {
      this.firstName = userInfo?.firstName || '?';
      this.lastName = userInfo?.lastName || '?';
    }
    this.setFullName();
  }

  @Input() containerCss = '';
  @Input() icon: EIcon;
  @Input() iconSize = 24;
  @Input() showFullName = false;
  @Input() showIcon = true;

  constructor(protected cdr: ChangeDetectorRef, private avatarService: AvatarService) {
    super(cdr);
  }

  ngOnInit(): void {}

  private setFullName() {
    this.fullName = `${this.firstName || ''} ${this.lastName || ''}`;
    this.cdr.detectChanges();
  }
}
